import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

// [merge-adapter: P8 perf] Panoramica/Calendario/Prenotazioni chiedevano
// ciascuna per conto proprio /resources e /services, sempre con la stessa
// richiesta senza parametri: la cache condivisa di QueryClientProvider (vedi
// App.js) fa si' che, navigando tra queste pagine nella stessa sessione, la
// seconda e la terza pagina riusino i dati gia' scaricati invece di rifare
// la stessa chiamata di rete. Nessun cambiamento nel formato dei dati
// restituiti (stesso array che le pagine gia' consumavano da r.data).

// Definizioni condivise con lib/startup-prefetch.js: stessa chiave e stessa
// funzione, cosi' la richiesta anticipata all'avvio popola la cache che poi
// leggono questi hook (e una richiesta gia' in corso viene riusata, non ripetuta).
export const resourcesQuery = {
  queryKey: ["resources"],
  queryFn: () => api.get("/resources").then(r => r.data || []),
};
export const servicesQuery = {
  queryKey: ["services"],
  queryFn: () => api.get("/services").then(r => r.data || []),
};

export function useResources() {
  const { data, isLoading, error } = useQuery(resourcesQuery);
  return { resources: data || [], resourcesLoading: isLoading, resourcesError: error };
}

export function useServices() {
  const { data, isLoading, error } = useQuery(servicesQuery);
  return { services: data || [], servicesLoading: isLoading, servicesError: error };
}
